import React, { useEffect, useState } from "react";

import camelCaseKeys from "camelcase-keys";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import {
  Routes,
  Route,
  useSearchParams,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  ScrollRestoration,
} from "react-router-dom-v5-compat";

import { getJsonRequest } from "Helpers/ApiRequest";

import BasicMenu from "./BasicMenu";
import Loading, { useLoadingState } from "./BasicMenu/Loading";
import MobileOrderingMenu from "./MobileOrderingMenu";
import { VenueSchema } from "./MobileOrderingMenu/schema";
import type { Venue } from "./MobileOrderingMenu/schema";

const MenuApp = () => {
  const [venue, setVenue] = useState<Venue | null>();
  const [searchParams, _] = useSearchParams();

  const venueUuid = (window as { venueUUID?: string }).venueUUID;
  if (!venueUuid) {
    return <div> Unable to get Menu Uuid</div>;
  }
  const menuUuid = (window as { menuUUID?: string }).menuUUID;
  if (!menuUuid) {
    return <div> Unable to get Menu Uuid</div>;
  }
  const loadingState = useLoadingState(async () => {
    const { body: venueResponse } = await getJsonRequest({
      url: `/marketing_api/venues/${venueUuid}`,
    });

    const parsedVenue = VenueSchema.parse(
      camelCaseKeys(venueResponse, { deep: true }),
    );
    if (searchParams.get("mobileMenuPreview")) {
      parsedVenue.enabledFeatures.onlineOrderingMenu = true;
    }

    setVenue(parsedVenue);
  }, []);

  // Explicitly setting the locale of onsite_app
  useEffect(() => {
    i18n.changeLanguage(venue?.locale);
  }, [venue]);

  return (
    <Loading loadingState={loadingState}>
      {venue && <MobileOrderingMenu menuUuid={menuUuid} venue={venue} />}
    </Loading>
  );
};

const Root = () => {
  return (
    <>
      <Routes>
        <Route path="*" element={<MenuApp />} />
        <Route path="*" element={<div> Fallback Route</div>} />
      </Routes>
      <ScrollRestoration />
    </>
  );
};

const baseRoute = (window as { baseRoute?: string }).baseRoute;
export const router = createBrowserRouter([{ path: "*", element: <Root /> }], {
  basename: baseRoute || undefined,
});
const App = () => {
  return <RouterProvider router={router} />;
};
export default App;
